import * as React from 'react';
import { connect } from 'react-redux';
import { toast } from '../../utilities/appToast';
import UploadFile from '../General/UploadFile';
import { fetchBancosApi, getDatosBancariosApi } from '../../api/axios';
import BigSpinner from '../General/BigSpinner';
import Select from 'react-select';
import { DropDownArrow, profileSelectStyle } from '../../template/CustomStyle';
import { getEstadoBancarioCbu } from '../../utilities/Seller/EstadoBancarioCbuSeller';
import PropTypes from 'prop-types';

class DatosBancarios extends React.Component {
    bancosRequestInFlight = null;

    constructor(props) {
        super(props);
        this.state = {
            datosBancarios: null,
            isLoading: true,
            formData: {
                banco: '',
                idSeller: this.props.idSeller,
                tipoCuenta: '',
                numeroCuenta: '',
                cbu: ''
            },
            bancos: [],
            selectedBanco: { value: '', label: 'Seleccione un banco' },
            selectedTipoCuenta: null,
            tiposCuenta: [
                { value: '1', label: 'Cuenta Corriente' },
                { value: '2', label: 'Caja de Ahorro' }
            ],
            isEditing: false,
            modoCarga: null, //'pdf' | 'form' | null
            isModificando: false,
        };
    }

    componentDidMount() {
        this.cargarDatosBancarios();
        this.cargarBancos();
    }

    normalizeBancos = (response) => {
        if (Array.isArray(response)) return response;
        if (Array.isArray(response?.bancos)) return response.bancos;
        if (Array.isArray(response?.elementos)) return response.elementos;
        if (Array.isArray(response?.content)) return response.content;
        if (Array.isArray(response?.Bancos)) return response.Bancos;
        if (Array.isArray(response?.Elementos)) return response.Elementos;
        if (Array.isArray(response?.Content)) return response.Content;
        return [];
    };

    extractDatoBancario = (response) => {
        if (!response) return null;
        if (Array.isArray(response)) return response[0] ?? null;
        if (response?.data && typeof response.data === 'object') return this.extractDatoBancario(response.data);
        if (Array.isArray(response?.elementos)) return response.elementos[0] ?? null;
        if (Array.isArray(response?.Elementos)) return response.Elementos[0] ?? null;
        if (Array.isArray(response?.content)) return response.content[0] ?? null;
        if (Array.isArray(response?.Content)) return response.Content[0] ?? null;
        if (response?.resultado && typeof response.resultado === 'object') return this.extractDatoBancario(response.resultado);
        if (response?.Resultado && typeof response.Resultado === 'object') return this.extractDatoBancario(response.Resultado);
        return response;
    };

    normalizeDatoBancario = (response) => {
        const raw = this.extractDatoBancario(response);
        if (!raw || typeof raw !== 'object') return null;

        return {
            ...raw,
            nroCuenta: raw?.nroCuenta ?? raw?.NroCuenta ?? raw?.numeroCuenta ?? raw?.NumeroCuenta ?? '',
            tipoCuenta: raw?.tipoCuenta ?? raw?.TipoCuenta ?? raw?.idTipoCuenta ?? raw?.IdTipoCuenta ?? '',
            cbu: raw?.cbu ?? raw?.Cbu ?? '',
            banco: raw?.banco ?? raw?.Banco ?? raw?.idBanco ?? raw?.IdBanco ?? '',
            estado: raw?.estado ?? raw?.Estado ?? 0,
        };
    };

    cargarDatosBancarios = async () => {
        const { idSeller } = this.props;

        const request = { IdSeller: idSeller };

        try {
            const datos = await getDatosBancariosApi(request);
            this.setState({ datosBancarios: this.normalizeDatoBancario(datos), isLoading: false });
        } catch {
            toast.error("No se pudieron cargar los datos bancarios.");
            this.setState({ isLoading: false });
        }
    }

    inputDatoBancarioFile = async (file) => {
        if (file.type !== "application/pdf") {
            toast.error("Solo se permiten archivos PDF.");
            return;
        }

        try {
            this.setState({ isEditing: true });
            this.props.onSendPdf(file);
        } catch {
            toast.error("Hubo un problema al procesar el archivo.");
        }
    };

    cargarBancos = async ({ force = false } = {}) => {
        if (!force && Array.isArray(this.state.bancos) && this.state.bancos.length > 0) {
            return;
        }

        if (this.bancosRequestInFlight) {
            return this.bancosRequestInFlight;
        }

        try {
            this.bancosRequestInFlight = fetchBancosApi();
            const bancos = await this.bancosRequestInFlight;
            const normalizedBancos = this.normalizeBancos(bancos);
            this.setState({ bancos: normalizedBancos });
        } catch {
            toast.error("No se pudieron cargar los bancos.");
        } finally {
            this.bancosRequestInFlight = null;
        }
    }

    selectSearchHandler = (option, { name }) => {
        let key = null;
        if (name === 'banco') key = 'selectedBanco';
        if (name === 'tipoCuenta') key = 'selectedTipoCuenta';

        this.setState(prevState => ({
            isEditing: true,
            [key]: option,
            formData: {
                ...prevState.formData,
                [name]: option?.value || ''
            }
        }));
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => {
            const updatedForm = {
                ...prevState.formData,
                [name]: value
            };

            const updatedState = { formData: updatedForm, isEditing: true };

            //Avisar al padre
            this.props.onChangeBankData?.(updatedForm);
            return updatedState;
        });
    }

    handleSeleccionModo = (modo) => {
        this.setState((prevState) => {
            let newState = {
                modoCarga: modo,
                isModificando: true,
                isEditing: false,
            };

            switch (modo) {
                case 'pdf': {
                    // Reiniciar el formulario
                    newState.formData = {
                        banco: '',
                        idSeller: this.props.idSeller,
                        tipoCuenta: '',
                        numeroCuenta: '',
                        cbu: ''
                    };
                    newState.selectedBanco = { value: '', label: 'Seleccione un banco' };
                    newState.selectedTipoCuenta = null;
                    break;
                }
                case 'form': {
                    // Reiniciar el input del PDF
                    const inputFile = document.getElementById("inputDatoBancarioFile");
                    if (inputFile)
                        inputFile.value = "";
                    break;
                }
                default:
                    break;
            }

            return newState;
        });
    };

    getBadgeStyle = (estado) => {
        const numEstado = Number(estado);

        const baseStyle = {
            color: '#fff',
            borderRadius: '6px',
            padding: '2px 10px',
            fontSize: '0.8rem',
            fontWeight: 'bold',
            textTransform: 'uppercase',
        };

        switch (numEstado) {
            case 2: // Aprobado
                return {
                    ...baseStyle,
                    backgroundColor: '#28a745', //verde
                };
            case 3: // Rechazado
                return {
                    ...baseStyle,
                    backgroundColor: '#dc3545', //rojo
                };
            case 4: // Borrado
                return {
                    ...baseStyle,
                    backgroundColor: '#6c757d', //gris Bootstrap (secondary)
                };
            default:
                return {
                    ...baseStyle,
                    backgroundColor: '#adb5bd', //gris claro para estados desconocidos
                };
        }
    };


    render() {
        const { datosBancarios, isLoading, formData, selectedBanco, modoCarga } = this.state;
        const tipoCuentaRaw =
            datosBancarios?.tipoCuenta ??
            datosBancarios?.idTipoCuenta ??
            datosBancarios?.TipoCuenta ??
            datosBancarios?.IdTipoCuenta;
        const tipoCuentaValue = Number(tipoCuentaRaw);
        const tipoCuentaLabel =
            tipoCuentaValue === 1
                ? 'Cuenta Corriente'
                : tipoCuentaValue === 2
                    ? 'Caja de Ahorro'
                    : '-';

        const sinDatos =
            !datosBancarios?.nroCuenta &&
            !(tipoCuentaValue === 1 || tipoCuentaValue === 2) &&
            !datosBancarios?.cbu &&
            !datosBancarios?.banco;

        const bancos = Array.isArray(this.state.bancos) ? this.state.bancos : [];

        const getBancoNombre = (idBanco) => {
            const banco = bancos.find(b => String(b?.id ?? b?.Id ?? b?.codigo ?? b?.Codigo) === String(idBanco));
            return banco ? (banco?.nombre ?? banco?.Nombre ?? banco?.descripcion ?? banco?.Descripcion) : idBanco || '-';
        };

        return (
            <div className="container">
                <div className="row justify-content-center">
                    {/* PANEL PDF */}
                    <div className="col-lg-5 mb-4 position-relative">
                        <div className="border rounded p-3 h-100 d-flex flex-column justify-content-center">
                            <label htmlFor="cargarPDF" className="text-center mb-3 fw-bold">
                                Adjuntar comprobante bancario (PDF)
                            </label>
                            <div className="text-center">
                                <UploadFile
                                    id="cargarPDF"
                                    acceptType={".pdf"}
                                    inputId={"inputDatoBancarioFile"}
                                    onFileLoaded={this.inputDatoBancarioFile}
                                    disabled={this.state.modoCarga !== 'pdf'}
                                    key={modoCarga === 'pdf' ? 'pdf-activo' : 'pdf-reset'}
                                />
                            </div>
                        </div>

                        {/* Overlay cuando no está habilitado */}
                        {this.state.modoCarga !== 'pdf' && (
                            <button
                                className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75 rounded"
                                style={{ cursor: 'pointer', zIndex: 10, border: "none" }}
                                onClick={() => this.handleSeleccionModo('pdf')}
                            >
                                <span className="fw-bold text-secondary">
                                    Haga click aquí para habilitar carga por .pdf
                                </span>
                            </button>
                        )}
                    </div>

                    {/* PANEL FORMULARIO */}
                    <div className="col-lg-5 mb-4 position-relative">
                        <div className="border rounded p-3">
                            <h5 className="mb-3">Información Bancaria</h5>

                            <fieldset disabled={this.state.modoCarga !== 'form'}>
                                <div className="form-group mb-3">
                                    <label htmlFor="selectBanco" className="label-oscura">Banco</label>
                                    <Select
                                        id="selectBanco"
                                        name="banco"
                                        value={selectedBanco ?? 'Seleccione un banco'}
                                        options={bancos.map(banco => ({
                                            value: banco?.id ?? banco?.Id ?? banco?.codigo ?? banco?.Codigo ?? '',
                                            label: banco?.nombre ?? banco?.Nombre ?? banco?.descripcion ?? banco?.Descripcion ?? ''
                                        }))}
                                        onChange={(option) => this.selectSearchHandler(option, { name: 'banco' })}
                                        onMenuOpen={() => this.cargarBancos()}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                        styles={profileSelectStyle}
                                        isSearchable={true}
                                        placeholder="Buscar banco..."
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="selectTipoCuenta" className="label-oscura">Tipo de Cuenta</label>
                                    <Select
                                        id="selectTipoCuenta"
                                        name="tipoCuenta"
                                        value={
                                            this.state.selectedTipoCuenta ||
                                            this.state.tiposCuenta.find(t => t.value === formData.tipoCuenta) ||
                                            null
                                        }
                                        options={this.state.tiposCuenta}
                                        onChange={(option) => this.selectSearchHandler(option, { name: 'tipoCuenta' })}
                                        getOptionValue={(option) => option.value}
                                        getOptionLabel={(option) => option.label}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                        styles={profileSelectStyle}
                                        placeholder="Seleccione tipo de cuenta"
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="numeroCuenta">Número de Cuenta</label>
                                    <input
                                        id="numeroCuenta"
                                        type="text"
                                        className="form-control"
                                        name="numeroCuenta"
                                        value={formData.numeroCuenta}
                                        onChange={this.handleInputChange}
                                        placeholder="Ingrese número de cuenta"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="cbu">CBU</label>
                                    <input
                                        id="cbu"
                                        type="text"
                                        className="form-control"
                                        name="cbu"
                                        value={formData.cbu}
                                        onChange={this.handleInputChange}
                                        placeholder="Ingrese CBU"
                                    />
                                </div>
                            </fieldset>
                        </div>

                        {/* Overlay cuando no está habilitado */}
                        {this.state.modoCarga !== 'form' && (
                            <button
                                className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75 rounded"
                                style={{ cursor: 'pointer', zIndex: 10, border: 'none' }}
                                onClick={() => this.handleSeleccionModo('form')}
                            >
                                <span className="fw-bold text-secondary">
                                    Haga click aquí para habilitar carga manual de datos
                                </span>
                            </button>
                        )}
                    </div>

                {/* SECCIÓN DE DATOS BANCARIOS EXISTENTES */}
                    {isLoading && (
                        <div className="d-flex justify-content-center align-items-center p-5">
                            <BigSpinner label="Cargando datos bancarios..." />
                        </div>
                    )}
                    {!isLoading && this.state.isModificando && (
                        <div className="d-flex flex-column justify-content-center align-items-center p-5 text-center">
                            <h5 className="my-2">MODIFICANDO DATOS BANCARIOS</h5>
                            <h6 className="mt-2 text-muted">Los datos bancarios se actualizarán luego de presionar "Guardar"</h6>
                        </div>
                    )}
                    {!isLoading && !this.state.isModificando && datosBancarios && !sinDatos && !this.state.isEditing ? (
                        <div className="d-flex justify-content-center mt-4">
                            <div className="form-group col-lg-6 border border-secondary rounded p-3 bg-white shadow-sm">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Datos Bancarios Asociados</h5>
                                    <span style={this.getBadgeStyle(datosBancarios?.estado)}>
                                        {getEstadoBancarioCbu(datosBancarios?.estado)}
                                    </span>
                                </div>

                                <div><strong>Número de cuenta:</strong> {datosBancarios?.nroCuenta}</div>
                                <div><strong>Tipo de cuenta:</strong> {tipoCuentaLabel}</div>
                                <div><strong>CBU:</strong> {datosBancarios?.cbu}</div>
                                <div><strong>Banco:</strong> {getBancoNombre(datosBancarios?.banco)}</div>
                            </div>
                        </div>
                    ) : (!isLoading && !this.state.isModificando && !this.state.isEditing) ? (
                        <h5 className="d-flex justify-content-center my-4">
                            NO HAY DATOS BANCARIOS ASOCIADOS
                        </h5>
                    ) : null}
                </div>
            </div>
        );
    }
}
DatosBancarios.propTypes = {
    idSeller: PropTypes.number,
    onSendPdf: PropTypes.func,
    onChangeBankData: PropTypes.func,
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(DatosBancarios);
